import type { Context } from 'react'
import { createContext } from 'react'
import type { BoMStateType } from 'storeContext/reducers/bom'
import type { BoMAddEditStateType } from 'storeContext/reducers/bom/bomAddEdit'
import type { BoMAddEditDispatchType } from 'storeContext/actions/bom/bomAddEdit'
import type { BoMDispatchType } from 'storeContext/actions/bom'

export interface BoMContextValueType {
  state: BoMStateType
  dispatch: BoMDispatchType
}

export interface BoMAddEditContextValueType {
  state: BoMAddEditStateType
  dispatch: BoMAddEditDispatchType
}

// Keep the original raw-state defaults and provider values.
export const createBoMContext = (initialState: BoMStateType) =>
  createContext(initialState) as unknown as Context<BoMContextValueType>

export const createBoMAddEditContext = (initialState: BoMAddEditStateType) =>
  createContext(initialState) as unknown as Context<BoMAddEditContextValueType>
